import {api} from '@/http'

// 职位收藏列表
const getFavoritesList = (data, callback, back) => {
  api('/api/favorites', 'get', data, callback, back)
}

// 关注列表
const getFollowList = (data, callback, back) => {
  api('/api/follow', 'get', data, callback, back)
}

// 取消收藏
const favoritesDel = (id, isActivity, callback, back) => {
  api('/api/position/' + id + '/favorites/', 'del', {isActivity}, callback, back)
}

// 职位申请
const favoritesApply = (id, isActivity, callback, back) => {
  api('/api/position/' + id + '/apply', 'post', {isActivity}, callback, back)
}

export default {
  getFavoritesList,
  getFollowList,
  favoritesDel,
  favoritesApply
}



// WEBPACK FOOTER //
// ./src/api/collect/index.js